import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay, ease: [0.2, 0.8, 0.2, 1] }}>
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark }) => (
  <div className={`inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] font-semibold font-mono ${dark ? "text-cyan-300" : "text-indigo-600"}`}>
    <span className={`w-6 h-px ${dark ? "bg-cyan-300" : "bg-indigo-600"}`} />{children}
  </div>
);

export const SectionHead = ({ eyebrow, title, sub, dark, center }) => (
  <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
    <h2 className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.08] ${dark ? "text-white" : "text-slate-900"}`}>{title}</h2>
    {sub && <p className={`mt-4 text-base md:text-lg leading-relaxed ${dark ? "text-slate-400" : "text-slate-600"}`}>{sub}</p>}
  </Reveal>
);
